import React, { useEffect, useState } from 'react'
import {
  Row,
  Col,
  Card,
  Form,
  Button,
  InputGroup,
  FormControl,
  DropdownButton,
  FloatingLabel,
  Dropdown,
  Table,
  Alert
} from 'react-bootstrap'

import { useForm } from 'react-hook-form'
import { CONFIG } from '../../config/constant'
import { BASE } from '../../basedata/constants'
import DatePicker, { registerLocale } from 'react-datepicker'
import ptBR from 'date-fns/locale/pt-BR'
import './visitorCreate.sass'

registerLocale('pt-br', ptBR)

import 'react-datepicker/dist/react-datepicker.css'

const maskCPF = (value: any) => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1')
}

// (00) 00000-0000
const maskPhone = (value: any) => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d{4})(\d)/, '$1-$2')
}

// 00000-000
const maskCEP = (value: any) => {
  return value.replace(/\D/g, '').replace(/^(\d{5})(\d{3})+?$/, '$1-$2')
}

// 00/00/0000
const maskDate = (value: any) => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d)/, '$1')
}

const isValidEmail = (email: any) =>
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email
  )

export function VisitorCreate() {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
    clearErrors,
    getValues,
    reset
  } = useForm()

  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())

  const [hasToken, setHasToken] = useState('')

  const [userQr, setUserQr] = useState('')

  const [disableSign, setDisableSign] = useState(false)

  const [visitorError, setVisitorError] = useState(false)

  const [userList, setUserList] = useState([])

  const getApprovers = () => {
    fetch(`${BASE.api.base_url}${BASE.api.access_approver}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: CONFIG.API_KEY
      }
    })
      .then((resg) => resg.json())
      .then((response) => {
        setUserList(response)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const onSubmit = (data: any) => {
    const dateFormate = data.birthday.split('/')
    const dateFormatePermanenceStart = new Date(startDate)
    const dateFormatePermanenceEnd = new Date(endDate)
    const validateDate = new Date(
      dateFormate[1] + '/' + dateFormate[0] + '/' + dateFormate[2]
    )
    const today = new Date()

    if (
      validateDate.getTime() > today.setHours(0, 0, 0, 0) ||
      validateDate.toString() === 'Invalid Date' ||
      data.birthday.length < 10
    ) {
      setError('birthday', {
        type: 'manual',
        message: 'Você precisa informar uma data válida'
      })
      return false
    }

    setDisableSign(true)
    fetch(`${BASE.api_user.base_url}${BASE.api_user.visitor_create}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': BASE.api.api_key
      },
      body: JSON.stringify({
        firstName: data.name.replace(/^\s+|\s+$/g, '').split(' ')[0],
        lastName: data.name.replace(/^\s+|\s+$/g, ''),
        externalId: 'visitor',
        gender: '',
        document: data.document.replace(/^\s+|\s+$/g, ''),
        document_type: '',
        email: data.email.replace(/^\s+|\s+$/g, '') || 'a@a.com',
        phoneNumber: data.phoneNumber
          .replace(/"/g, '')
          .replace(/'/g, '')
          .replace(/\(|\)/g, ''),
        birthDate: dateFormate[2] + '/' + dateFormate[1] + '/' + dateFormate[0],
        performanceStart: dateFormatePermanenceStart,
        performanceEnd: dateFormatePermanenceEnd,
        approver: data.approver.replace(/^\s+|\s+$/g, ''),
        observation: data.observation,
        nationality: '',
        accessCode: 'visitor',
        originCompanyId: 'd5c19737-7e4e-4dd8-9931-d6bc3bc961d1'
      })
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.onboarding_url) {
          const currentToken =
            response.onboarding_url.split('com.br/?token=')[1]

          setUserQr(response.qr)
          setHasToken(currentToken)
        }
      })
      .catch((error) => {
        setVisitorError(true)

        setTimeout(() => {
          setVisitorError(false)
        }, 4000)
        console.log(error)
      })
  }

  const printImage = (data: any) => {
    const myImage = data
    const myWindow = window.open('', 'Image')
    myWindow!.document.write("<img src='" + myImage + "''>")
    myWindow!.print()
  }

  const resetForm = () => {
    setHasToken('')
    setDisableSign(false)
    reset({
      document: '',
      name: '',
      birthday: '',
      email: '',
      phoneNumber: '',
      observation: ''
    })
  }

    const searchVisitor = (document:string) => {


    fetch(`${BASE.api_user.base_url}${BASE.api_user.visitor_find_by_document}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': BASE.api.api_key
      },
      body: JSON.stringify({
        document: document
      })
    })
      .then((res) => res.json())
      .then((response) => {
        console.log(response)
        if(response && response.id){

          const customData = response.birthDate.split('-')
          reset({
            name: `${response.firstName} ${response.lastName}`,
            birthday: maskDate(`${customData[2]}/${customData[1]}/${customData[0]}`),
            email: response.email,
            phoneNumber: response.phoneNumber,
          })
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  useEffect(() => {
    getApprovers()
  }, [])

  return (
    <Card>
      {/* <Card.Header>
        <Card.Title as="h5">Cadastro de Visitante</Card.Title>
      </Card.Header> */}
      <Card.Body>
        <Row>
          <Col>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Row className="mb-3">
                <Col sm={12} xl={6}>
                  <Form.Label>Documento (CPF)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Documento (CPF)"
                    {...register('document')}
                    onChange={(event) => {
                      const { value } = event.target
                      event.target.value = maskCPF(value)
                    }}
                    onBlur={(event) => {searchVisitor(event.target.value)}}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col sm={12} xl={6}>
                  <Form.Label>Nome Completo</Form.Label>
                  <Form.Control placeholder="Nome" {...register('name')} />
                </Col>
                <Col sm={12} xl={6}>
                  <Form.Label>Data Nascimento</Form.Label>
                  <Form.Control
                    placeholder="DD/MM/YYYY"
                    {...register('birthday')}
                    onChange={(event) => {
                      const { value } = event.target
                      event.target.value = maskDate(value)
                    }}
                  />
                  {errors.birthday && (
                    <span className="label-error">
                      Você precisa informar uma data válida
                    </span>
                  )}
                </Col>
              </Row>
              <Row className="mb-3">
                <Col sm={12} xl={6}>
                  <Form.Label>E-mail</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="E-mail"
                    {...register('email')}
                  />
                  {errors.email && (
                    <span className="label-error">
                      Você precisa informar um E-mail válido
                    </span>
                  )}
                </Col>
                <Col sm={12} xl={6}>
                  <Form.Label>Celular</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Celular"
                    {...register('phoneNumber')}
                    onChange={(event) => {
                      const { value } = event.target
                      event.target.value = maskPhone(value)
                    }}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col sm={12} xl={6}>
                  <Form.Label>Liberação de:</Form.Label>
                  <DatePicker
                    className="form-control"
                    locale="pt-br"
                    dateFormat="dd/MM/yyyy"
                    selected={startDate}
                    onChange={(date: Date) => setStartDate(date)}
                  />
                </Col>
                <Col sm={12} xl={6}>
                  <Form.Label>Liberação até:</Form.Label>
                  <DatePicker
                    className="form-control"
                    locale="pt-br"
                    dateFormat="dd/MM/yyyy"
                    selected={endDate}
                    onChange={(date: Date) => setEndDate(date)}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col sm={12} xl={6}>
                  <Form.Label>Solicitante</Form.Label>
                  {/* <Form.Control
                    placeholder="Quem liberou?"
                    {...register('approver')}
                  /> */}
                  <Form.Group controlId="exampleForm.ControlSelect1">
                    <select
                      className="form-control"
                      {...register('approver', { required: true })}
                    >
                      {userList &&
                        userList.map((user: any) => (
                          <option key={user.id} value={user.id}>
                            {user.name}
                          </option>
                        ))}
                    </select>
                  </Form.Group>
                </Col>
                <Col sm={12} xl={6}>
                  <Form.Label>Observações</Form.Label>
                  <Form.Control placeholder="" {...register('observation')} />
                </Col>
              </Row>
              <Row>
                <Col sm={12} xl={6}>
                  <Form.Group>
                    <Button
                      disabled={disableSign}
                      type="submit"
                      className="mb-0 w-100"
                      onClick={() => clearErrors()}
                    >
                      Cadastrar Visitante
                    </Button>
                  </Form.Group>
                </Col>
                <Col sm={12} xl={6}>
                  {disableSign && (
                    <Form.Group>
                      <Button
                        className="mb-0 btn-success w-100"
                        onClick={() => resetForm()}
                      >
                        Cadastrar Novo
                      </Button>
                    </Form.Group>
                  )}
                </Col>
              </Row>
              {visitorError && (
                <Alert variant="danger mt-3">
                  Não foi possível cadastrar o visitante. Por favor, tente
                  novamente em 5minutos
                </Alert>
              )}
            </Form>
          </Col>
        </Row>

        {hasToken && (
          <>
            <hr />
            <Row>
              <Col className="qr-wrapper">
                <h3 className="text-center">
                  Clique abaixo para Tirar a Foto ou imprimir o QR
                </h3>
                {/* <img
                  src={`https://api.qrserver.com/v1/create-qr-code/?size=300x300&bgcolor=ffffff&data=https://visitante-palmeiras.bepass.com.br/?token=${hasToken}`}
                  className="qr-code"
                  alt="Palmeiras"
                /> */}
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <a
                  className="qr-link"
                  target="_blank"
                  rel="noreferrer"
                  href={`https://visitante-palmeiras.bepass.com.br/?token=${hasToken}`}
                >
                  Tirar Foto
                </a>
              </Col>
              <Col sm={6}>
                <a
                  className="qr-link"
                  onClick={() => {
                    printImage(userQr)
                  }}
                >
                  Imprimir QR Code
                </a>
              </Col>
            </Row>
          </>
        )}
      </Card.Body>
    </Card>
  )
}
